module.exports = __webpack_public_path__ + "img/1490716123.8d757b0c.jpg";